// extracted by mini-css-extract-plugin
export default {"root":"cz5Ryg","debugBorder":"UCNva4"};